import {authRoutes} from 'pages/auth/routes';
import {FarmRoutes} from 'pages/farm/routes';
import {FarmChatRoutes} from 'pages/farmChat/routes';
import NotFound from 'pages/notFound';
import {WholesalerChatRoutes} from 'pages/wholeSalerChat/routes';
import {WholesalerRoutes} from 'pages/wholesaler/routes';
import {Navigate, createBrowserRouter} from 'react-router-dom';

export const routes = createBrowserRouter([
  {path: '*', element: <NotFound />},
  {path: '/', element: <Navigate replace to="wholesaler/home" />},
  ...FarmRoutes,
  ...WholesalerRoutes,
  ...authRoutes,
  ...FarmChatRoutes,
  ...WholesalerChatRoutes,
]);
